import {
  SET_MAP,
  SET_CURRENT_LAT_LNG,
  SET_POS,
  SET_DISTANCE,
  SET_SERVICE,
  SET_CURRENT_DISTANCE,
  SET_CURRENT_SERVICE,
  UNSET_CURRENT_SERVICE,
  RESET_CURRENT_SERVICE,
  SET_ACTIVE_TAB,
  SET_MARKERS,
  SET_SEARCH,
} from '@/storeFinder/context/types';

export const setMap = payload => ({ type: SET_MAP, payload });
export const setLatLng = payload => ({ type: SET_CURRENT_LAT_LNG, payload });
export const setPos = payload => ({ type: SET_POS, payload });
export const setDistance = payload => ({ type: SET_DISTANCE, payload });
export const setService = payload => ({ type: SET_SERVICE, payload });
export const setCurrentDistance = payload => ({
  type: SET_CURRENT_DISTANCE,
  payload,
});
export const setCurrentService = payload => ({
  type: SET_CURRENT_SERVICE,
  payload,
});
export const unsetCurrentService = payload => ({
  type: UNSET_CURRENT_SERVICE,
  payload,
});
export const resetCurrentService = payload => ({
  type: RESET_CURRENT_SERVICE,
  payload,
});
export const setActiveTab = payload => ({ type: SET_ACTIVE_TAB, payload });
export const setMarkers = payload => ({ type: SET_MARKERS, payload });
export const setSearch = payload => ({ type: SET_SEARCH, payload });
